(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-bento"] && !Shopify.designMode) return;
  try {
    
  /* Play/pause background videos when cards enter/leave the viewport.
     Desktop only (mobile hides videos via CSS) and skipped entirely
     for reduced-motion users. */
  (() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(max-width: 749px)').matches) return;

    const videos = document.querySelectorAll('.cat-card__video');
    if (!videos.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            const playing = video.play();
            if (playing !== undefined) {
              playing.then(() => video.classList.add('is-playing')).catch(() => {});
            }
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.25 }
    );

    videos.forEach((video) => observer.observe(video));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  /* Tab switching via event delegation — one listener for every
     product-tabs section on the page, and it keeps working after the
     theme editor re-renders the section (no per-node bindings). */
  if (!window.__amzTabsBound) {
    window.__amzTabsBound = true;
    document.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-amz-tab]');
      if (!btn) return;
      const root = btn.closest('[data-amz-tabs]');
      if (!root) return;
      const idx = btn.getAttribute('data-amz-tab');
      root.querySelectorAll('[data-amz-tab]').forEach((b) => {
        const active = b === btn;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      root.querySelectorAll('[data-amz-panel]').forEach((panel) => {
        panel.hidden = panel.getAttribute('data-amz-panel') !== idx;
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-bar"] && !Shopify.designMode) return;
  try {
    
  function animateStat(el) {
    const value = parseInt(el.dataset.value, 10) || 0;
    const prefix = el.dataset.prefix || '';
    const suffix = el.dataset.suffix || '';
    const duration = 1400;
    const start = performance.now();

    function step(now) {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = Math.round(value * eased);
      el.textContent = `${prefix}${current.toLocaleString('es-MX')}${suffix}`;
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  const statObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateStat(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.4 }
  );

  document.querySelectorAll('[data-stat-number]').forEach((el) => statObserver.observe(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-us-sticky"] && !Shopify.designMode) return;
  try {
    
  /* Count-up for numeric reason cards (same mechanic the old stats-bar used) */
  (() => {
    function animateNumber(el) {
      const value = parseInt(el.dataset.value, 10) || 0;
      const prefix = el.dataset.prefix || '';
      const suffix = el.dataset.suffix || '';

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        el.textContent = `${prefix}${value.toLocaleString('es-MX')}${suffix}`;
        return;
      }

      const duration = 1400;
      const start = performance.now();

      function step(now) {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = `${prefix}${Math.round(value * eased).toLocaleString('es-MX')}${suffix}`;
        if (progress < 1) requestAnimationFrame(step);
      }

      requestAnimationFrame(step);
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateNumber(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );

    document.querySelectorAll('[data-why-number]').forEach((el) => observer.observe(el));
  })();

  } catch(e) { console.error(e); }
})();
})();
